import { render, staticRenderFns } from "./MMainNotice.vue?vue&type=template&id=7261b4c6&scoped=true&"
import script from "./MMainNotice.vue?vue&type=script&lang=js&"
export * from "./MMainNotice.vue?vue&type=script&lang=js&"
import style0 from "./MMainNotice.vue?vue&type=style&index=0&id=7261b4c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7261b4c6",
  null
  
)

export default component.exports